<template>
  <div class="form-wrapper">

    <div class="form-alert-errors" v-if="serverErrors && serverErrors.length > 0">
      <ul class="list-unstyled m-0">
        <li v-for="(error, i) in serverErrors" :key="i">{{ error }}</li>
      </ul>
    </div>

    <form @submit.prevent="doLogin">
      <div class="intro-section__form">
        <div class="form-group">
          <input
              type="email"
              v-model="email"
              required
              class="input form-control"
              :placeholder="$t('forms.login_form.email')"
          />
        </div>

        <div class="form-group">
          <input-password
              v-model="password"
              :required="true"
              :placeholder="$t('forms.login_form.password')"
          />
        </div>

        <div class="form-group m-0">
          <button type="submit" class="btn btn-primary m-0 w-100" :disabled="loading">{{ $t('forms.login_form.login_btn') }}</button>
        </div>
      </div>

      <div class="form-group text-center mb-5">
        <router-link :to="{ name: 'reset-password' }">{{ $t('forms.login_form.forgot_password_btn') }}</router-link>
      </div>
      <SocialLogin v-if="showSocialLogin"/>
      <div class="row d-lg-flex align-items-center mt-4" v-if="thirdLevelDomain==='hublot'">
        <div class="col-lg-12">
          <PoweredBy
              :url="'https://business.getpica.com/?utm_source=hublot.getpica.com&utm_medium=website&utm_campaign=hublot'"/>
        </div>
      </div>
    </form>

  </div>
</template>


<script>
import InputPassword from "@/components/InputPassword";
import SocialLogin from "@/components/SocialLogin";
import PoweredBy from "@/components/PoweredBy.vue";
import {mapActions, mapGetters} from "vuex";
import {isNavigationFailure} from "vue-router";

export default {
  components: {PoweredBy, InputPassword, SocialLogin},
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      serverErrors: []
    }
  },

  computed: {
    ...mapGetters(['thirdLevelDomain']),
    ...mapGetters('auth', ['hasAcceptedRequiredPolicies']),
    ...mapGetters('appConfig', ['getAppConfigReady', 'disableSocialLogin']),
    showSocialLogin() {
      if (!this.getAppConfigReady) return false
      if (this.disableSocialLogin) return false
      if (['photos'].includes(this.thirdLevelDomain)) return false
      return true
    },
  },

  methods: {
    ...mapActions('auth', [
      'login',
      'getCurrentUser',
    ]),
    async doLogin() {
      // The form can be submitted twice (double click, password manager auto-submit + click):
      // a second login would push the same route again and cancel the first navigation
      if (this.loading) return
      this.loading = true
      try {
        try {
          this.serverErrors = []
          await this.login({
            email: this.email,
            password: this.password
          })
        } catch (error) {
          this.serverErrors = error.response.data.non_field_errors
          return
        }

        await this.getCurrentUser()

        // Check if the user has accepted required policies
        const nextRoute = this.hasAcceptedRequiredPolicies
            ? {name: 'checkins-list'}
            : {name: 'terms', params: {next: 'checkins-list'}}
        await this.$router.push(nextRoute).catch(err => {
          if (!isNavigationFailure(err)) throw err
        })
      } finally {
        this.loading = false
      }
    }
  }
};
</script>
